import { Airport, FlightSegment } from '@prisma/client';

export const airports = (
  flightSegments: (FlightSegment & { origin_airport: Airport; destination_airport: Airport })[],
): Airport[] => {
  return flightSegments.reduce((acc, segment, index) => {
    if (index === 0) return [segment.origin_airport, segment.destination_airport];
    return [...acc, segment.destination_airport];
  }, []);
};
